// CommitChart.js
import {Bar, mixins} from 'vue-chartjs'
const {reactiveData} = mixins;

import GraphApi from '../../../../api/Graphs/index'
import GraphManager from '../../../../helpers/GraphManager'
import config from '../../../../config/index'

let fromDate = moment().subtract(1, 'month');
let toDate = moment();


export default {
  name: 'bar-graph',
  extends: Bar,
  mixins: [reactiveData],
  props: {
    type: {
      type: String,
    },
    userId: {
      type: Number
    },
    fromDate: {
      type: String,
      default: fromDate.format('YYYY-MM-DD')
    },
    toDate: {
      type: String,
      default: toDate.format('YYYY-MM-DD')
    },
    medTrackingId: {
      type: Number
    }
  },
  watch: {
    'fromDate': function () {
      let self = this;
      self.loadData();
    }
  },
  name: 'bar-graph',
  data(){
    return {
      chartData: null,
      series: [],
      data: [],
      Labels: [],
      override: [],
      dataset: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: "white",
            fontSize: 14,
            usePointStyle: true,
            padding: 16
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              autoSkip: true,
              fontColor: "white",
              fontSize: 14,
              beginAtZero: false,
              maxRotation: 0,
              minRotation: 0
            },
            gridLines: {
              display: true,
              color: 'rgba(255, 255, 255, 0.15)',
              zeroLineColor: 'transparent'
            },
          }],
          xAxes: [{
            ticks: {
              autoSkip: true,
              fontColor: "white",
              fontSize: 14,
              stepSize: 2,
              beginAtZero: true,
              zeroLineColor: 'transparent',
              showXAxisLabel: false,
              maxRotation: 0,
              minRotation: 0
            },
            gridLines: {
              display: true,
              color: "rgba(255, 255, 255, 0.15)",
              zeroLineColor: 'transparent'
            },
          }]
        }
      }
    }
  },
  mounted() {
    let self = this;
    self.loadData();
  },
  methods: {
    loadData() {
      let self = this;
      self.$emit('graphLoading', true);
      GraphManager.handleGraphType(self);
    },
    renderChartFromData(response) {
      let self = this;
      self.data = response.data.data;
      self.labels = response.data.labels;
      self.series = response.data.series;
      self.override = response.data.override;
      self.dataset = [];
      const dataLength = self.data.length;
      for (let i = 0; i < dataLength; i++) {
        self.dataset.push({
          label: self.series[i],
          data: self.data[i],
          backgroundColor: self.override[i].backgroundColor,
          borderColor: self.override[i].borderColor,
          pointBackgroundColor: self.override[i].borderColor,
          pointBorderColor: self.override[i].pointBorderColor,
          borderWidth: self.override[i].borderWidth,
          borderDash: self.override[i].borderDash
        })
      }

      const labelLength = self.labels.length;
      for (let i = 0; i < labelLength; i++) {
        self.labels[i] = config.dateFormatting.graphLabels(self.labels[i])
      }

      if (self.chartData) {
        self.chartData = {
          labels: self.labels,
          datasets: self.dataset
        };
      }
      else {
        self.chartData = {
          labels: self.labels,
          datasets: self.dataset
        };
        self.renderChart(self.chartData,
          {
            tooltips: {
              cornerRadius: 4,
              mode: "nearest",
              callbacks: {
                label: function (tooltipItem, data) {
                  return tooltipItem.yLabel + ' ' + data.datasets[tooltipItem.datasetIndex].label
                }
              },
              displayColors: true,
              intersect: false,
              xPadding: 16,
              yPadding: 16,
              titleFontFamily: 'Poppins',
              titleFontStyle: '200',
              bodyFontFamily: 'Poppins',
              backgroundColor: '#0179d5',
              titleFontSize: 16,
              titleFontColor: 'white',
              bodyFontColor: 'white',
              bodyFontSize: 14
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              labels: {
                fontColor: "white",
                fontSize: 14,
                usePointStyle: true,
                padding: 16
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  fontFamily: 'Poppins',
                  autoSkip: true,
                  fontColor: "white",
                  fontSize: 14,
                  beginAtZero: false,
                  maxRotation: 0,
                  minRotation: 0
                },
                gridLines: {
                  display: true,
                  color: 'rgba(255, 255, 255, 0.15)',
                  zeroLineColor: 'transparent'
                },
              }],
              xAxes: [{
                ticks: {
                  fontFamily: 'Poppins',
                  autoSkip: true,
                  fontColor: "white",
                  fontSize: 14,
                  stepSize: 2,
                  beginAtZero: true,
                  zeroLineColor: 'transparent',
                  showXAxisLabel: false,
                  maxRotation: 0,
                  minRotation: 0
                },
                gridLines: {
                  display: true,
                  color: "rgba(255, 255, 255, 0.15)",
                  zeroLineColor: 'transparent'
                },
              }]
            }
          }
        );
      }
      self.$forceUpdate();
      self.$emit('graphLoading', false);
      self.$emit('graphLoaded', response)

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Tracking/Graph/Bar/index.js